import { Button } from 'react-bootstrap'
import Cookies from 'universal-cookie'
import { getPubAbbr } from '@revbox/helpers-fe'
import { cookiesKeyNames } from '@revbox/common-fe'
import { brendingActionButtons, statusLabels } from '@revbox/localization'
import { TaxonomyModule } from '../../../../../modules/taxonomy'
import { getPathKey, useCookiesContext } from '../../../../../contexts/CookiesContext'

export function ClusterActionRenderer({ data, value }) {
    const { getLanguageAbbr } = useCookiesContext()
    const language = getLanguageAbbr()
    const { startBidding, updateBid, locked, unavailable } = brendingActionButtons[language]

    if (!value) {
        return null
    }
    
    const status = value.split('@')[0]
    // const parentBidIsDisactivated = value.split('@')[1] === 'true'
    // const isAnyChildActive = value.split('@')[2] === 'true'
    const allowedToBid = value.split('@')[3] === 'true'
    const isParentOnReview = value.split('@')[4] === 'true'
    const noViews = value.split('@')[5] === 'true'
    // const no_campaign_relation_via_categories = value.split("@")[7] === 'true';
    // const urlParams = new URLSearchParams(window.location.search)
    // const campaignId = urlParams.get('campaignId')
    // const advId = urlParams.get('advId')

    // const openStats = () => {
    //     window.open(`/adv/campaign/ppc/clustering?inventoryId=${data.ID}&campaignId=${campaignId}&advId=${advId}`, '_blank')
    // }

    if ( // Start bidding
      allowedToBid &&
      (
        status === statusLabels[language]['Inactive'] ||
        status === statusLabels[language]['Draft'] ||
        status === statusLabels[language]['Inherited']
      ) && 
      !isParentOnReview
    ) {
      if (noViews) {
        return (
          <Button
            variant="outline"
            size="sm"
            className=""
            style={{ marginLeft: '0px', width: '130px' }}
            disabled
          >
            <i className="ri-lock-2-line me-1"></i>
            <span style={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}>
              {unavailable}
            </span>
          </Button>
        )
      }

      return (
        <Button
          variant="outline-primary"
          id="start-bidding"
          size="sm"
          className=""
          style={{ marginLeft: '0px', width: '130px' }}
        >
          <span style={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}>{startBidding}</span>
        </Button>
      )
    }

    if ( // Update bid
      allowedToBid &&
      (
        status !== statusLabels[language]['Inactive'] &&
        status !== statusLabels[language]['Draft'] &&
        status !== statusLabels[language]['Inherited']
      ) && 
      !isParentOnReview
    ) {
      if (noViews) {
        return (
          <Button
            variant="outline"
            size="sm"
            className=""
            style={{ marginLeft: '0px', width: '130px' }}
            disabled
          >
            <i className="ri-lock-2-line me-1"></i>
            <span style={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}>
              {unavailable}
            </span>
          </Button>
        )
      }

      return (
        <Button
          variant={'primary'}
          size="sm"
          id="start-bidding"
          className=""
          style={{ marginLeft: '0px', width: '130px' }}
        >
          <span style={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}>{updateBid}</span>
        </Button>
      )
    }

    // Locked
    return (
      <Button
        variant="outline-primary"
        size="sm"
        className=""
        style={{ marginLeft: '0px', width: '130px' }}
        disabled
      >
        <i className="ri-lock-2-line me-1"></i>
        <span style={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}>
          {locked}
        </span>
      </Button>
    )

  //   return (
  //     <div>
  //         {/* <Button variant="outline-primary" size="sm" className="" onClick={openStats}>
  //   <i className="ri-bar-chart-line"></i>
  // </Button> */}
  //         <Button
  //             variant={noAllowed ? 'outline-primary' : 'primary'}
  //             size="sm"
  //             className=""
  //             style={{ marginLeft: '0px', width: '130px' }}
  //             disabled={noAllowed}
  //         >
  //             {noAllowed ? (
  //                 <>
  //                     <i className="ri-lock-2-line"></i> <span style={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}>{locked}</span>
  //                 </>
  //             ) : (
  //                 <span style={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}>{updateBid}</span>
  //             )}
  //         </Button>
  //     </div>
  // )
}

export function ClusterActionCellColumnHeaderTooltipRenderer() {
    const publisherIdByAbbr = getPubAbbr()
    const taxonomy = TaxonomyModule(publisherIdByAbbr)

    return taxonomy.tooltips.ppc_cluster_column_headers.action
}

export function ClusterActionCellTooltipRenderer(params) {
    const { value, data } = params || {}
    const publisherIdByAbbr = getPubAbbr()
    const taxonomy = TaxonomyModule(publisherIdByAbbr)
    const cookies = new Cookies()
    const pathKey = getPathKey()
    const languageAbbr = cookies.get(pathKey)?.[cookiesKeyNames.language]?.value || 'EN'

    if (!value) {
        return null
    }
    
    // Parse value components
    const [status, parentBidIsDisactivatedRaw, , allowedToBidRaw, , noViewsRaw] = value.split('@')
    let parentBidIsDisactivated = parentBidIsDisactivatedRaw == 'true'
    const allowedToBid = allowedToBidRaw === 'true'
    const noViews = noViewsRaw === 'true'

    // Determine cluster level from node hierarchy (consistent with ClusterNameRenderer)
    // node.level: 0 = DC, 1 = C1, 2 = C2
    const isC1 = params.node?.level === 1
    const isC2 = params.node?.level === 2

    // Handle unavailable clusters (no views) - check first, regardless of allowedToBid
    if (noViews) {
        if (isC1) {
            return taxonomy.tooltips.ppc_cluster_column_inlines.action.unavailable_no_views
        } else if (isC2) {
            return taxonomy.tooltips.ppc_cluster_column_inlines.action.c2_unavailable
        }
        return taxonomy.tooltips.ppc_cluster_column_inlines.action.unavailable_no_views
    }

    // For C1 clusters there is no parent above (Department Cluster is parent), so ignore parent deactivation tooltip
    if (isC1) {
        parentBidIsDisactivated = false
    }

    if (parentBidIsDisactivated) {
        return taxonomy.tooltips.ppc_cluster_column_inlines.action.parent_bid_is_disactivated
    }

    // Handle inactive/draft status
    if (status === statusLabels[languageAbbr]['Inactive'] || status === statusLabels[languageAbbr]['Draft'] || status === statusLabels[languageAbbr]['Inherited']) {
        if (isC1 && allowedToBid && !noViews) {
            return taxonomy.tooltips.ppc_cluster_column_inlines.action.c1_inactive_can_bid
        }
        return taxonomy.tooltips.ppc_cluster_column_inlines.action.start_bidding
    }
    
    // Default to update bid
    return taxonomy.tooltips.ppc_cluster_column_inlines.action.update_bid
}
